import { Injectable, inject } from '@angular/core';

import { LenderPackagers } from '@shared/models/lender-packagers';
import { UpdatePackagerRelationshipsRequest } from '@shared/models/update-packager-relationships-request';
import { LenderHubDataService } from '@shared/services/lenderhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class PackagerRelationshipsService {
  private readonly lenderHubDataService = inject(LenderHubDataService);

  public getAvailablePackersForLender(lenderNameId: number) {
    return this.lenderHubDataService.get<LenderPackagers>(`LenderName/AvailablePackagers/${lenderNameId}`);
  }

  public updatePackagerRelationships(lenderNameId: number, request: UpdatePackagerRelationshipsRequest[]) {
    return this.lenderHubDataService.post(`LenderName/PackagerRelationships/${lenderNameId}`, request);
  }
}
